export default "__VITE_ASSET__b880f42d__"